import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';
import { VeraScoreChangeText } from '../../atoms/vera-score';

export interface Props {
  className?: string;
  children?: any;
  change?: number;
  score: number;
  isLarge?: boolean;
  title: string;
}

class VeraScoreChange extends React.Component<Props, any> {
  render() {
    const { className, children, change, isLarge, score, title } = this.props;
    const isValidScore = !!(score && score > 0);
    return (
      <div className={className}>
        {children && <div className="change-graphic">{children}</div>}
        <div>
          <div className={`title ${isLarge ? 'large' : ''}`}>{title}</div>
          <span className={`score ${isLarge ? 'large' : ''}`}>
            {isValidScore ? score : '-'}
          </span>{' '}
          <VeraScoreChangeText score={change} />
        </div>
      </div>
    );
  }
}

const StyledVeraScoreChange = styled(VeraScoreChange)`
  color: ${colors.text};
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1.1;

  .change-graphic {
    margin-right: 1.33em;
  }
  .score {
    font-size: 2em;
  }
  .large.title {
    font-size: 1.15em;
  }
  .large.score {
    font-size: 3.3em;
  }
`;

export default StyledVeraScoreChange;
